import * as React from "react";
import { Button, Dropdown, Form } from "react-bootstrap";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import OutsideClickHandler from "react-outside-click-handler";
import profile from "../Assets/Images/profile.png";
import { EntityManagementService } from "../Services/EntityManagementService";
import { request } from "http";
import { resolve, reject } from "q";
import { Utils } from "../Utilis";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export class DailyTaskAssignedToList extends React.Component<any, any> {
  private inputElement: any;
  private dropdownMenuRef: any;
  constructor(props: any) {
    super(props);
    this.inputElement = React.createRef();
    this.dropdownMenuRef = React.createRef();
    this.state = {
      row: this.props.row,
      inputValue: "",
      assignedToList: this.props.assignedToList || [],
      filterTypeList: [],
      assignedTo: this.props?.row?.assignedTo || '',
      refreshKey: 0,
      filterList: [],
      filteredList: [],
      copyFilterList: [],
    };
    this.handleSearchType = this.handleSearchType.bind(this);
  }


  componentDidMount() {
    this.setState({filteredList : this.props.assignedToList , copyFilterList : this.props.assignedToList});
  }



  handleDropdownChange(item) {
    this.setState({ inputValue: "" });
    this.props.assignedToSelected(item, this.state.row);
  }

  handleSearchType = (e: { target: { value: string } }) => {

    this.setState({ loaderTrue: true, inputValue: e.target.value });
    let data = [...this.state.copyFilterList]
    const updatedList = data.filter(
      (item: { name: string }) => {
        return (
          item.name.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1
        );
      }
    );

    this.setState({ filteredList: [] }, () => {
      this.setState({
        inputValue: e.target.value,
        loaderTrue: false,
        filteredList: updatedList,

      });
    })

  };

  callFromParent = () => {

  }

  hideDropdown = () => {
    $(".edit-dropdown").hide();
  }

  render() {
    return (

      <div className="subtype-wrapper" >
        <Dropdown
          className="subtype-dropdown position-static"
          onToggle={(isOpen) => {
            if (!isOpen) {
              this.setState({ inputValue: "" , filteredList : this.state.copyFilterList });
            }
          }}
        >
          <Dropdown.Toggle
            id="dropdown-importFrom"
            className={this.props?.row?.assignedToValidation ? "alert-danger" : ""}
          >
            <div className="btn-text">
              <EllipsisWithTooltip placement="bottom">{this.state.assignedTo || "Select Assigned To"}</EllipsisWithTooltip>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu
            ref={this.dropdownMenuRef}
            onWheel={(e) => e.stopPropagation() }
          >
            <div className="dropdown-content">
              <div className="search-sec">
                <input
                  type="text"
                  className="form-control"
                  onChange={this.handleSearchType}
                  placeholder="Search Assigned To"
                  value={this.state.inputValue}
                  ref={this.inputElement}
                />
              </div>
              <div className="menu"
                onWheel={() => this.hideDropdown()}
              >
                {this.state.filteredList?.length > 0 ? (
                  this.state.filteredList.map((item: any) => (
                    <Dropdown.Item
                      onClick={() => this.handleDropdownChange(item)}
                      key={item.id}
                    // className="position-static"

                    >
                      <div className="d-flex align-items-center justify-content-between" style={{ flex: 1 }}
                      >
                        <div className="type-name">
                          <EllipsisWithTooltip placement="bottom">{item.name}</EllipsisWithTooltip>
                        </div>

                       
                      </div>

                      </Dropdown.Item>
                    ))
                  ) : (
                    <></>
                  )}
                  </div>
                 
             
            </div>
          </Dropdown.Menu>
        </Dropdown>

      </div>
    );
    //   </OutsideClickHandler>


  }
}